import { render, staticRenderFns } from "./ProductSetPrices.vue?vue&type=template&id=70511cfa"
import script from "./ProductSetPrices.vue?vue&type=script&lang=js"
export * from "./ProductSetPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports